import { Pipe, PipeTransform } from '@angular/core';
import linkifyHtml from 'src/shared/util/linkify';

@Pipe({
  name: 'linkify',
  standalone: true,
  pure: true
})
export class LinkifyPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    return linkifyHtml(value, { target: '_blank' });
  }
}
